module.exports = "<div class=\"wrapper\">\n  <div *ngIf=\"saving\" class=\"saving\">\n    <span class=\"spinning icon ion-load-c\"></span>\n  </div>\n  <span class=\"text\">{{value}}</span>\n  <input type=\"text\" *ngIf=\"type === 'input'\" [value]=\"value\" #input (keyup)=\"setText(input.value)\" (blur)=\"saveData(input.value)\" class=\"editable\" />\n  <textarea *ngIf=\"type === 'textarea'\" #textarea (keyup)=\"setText(textarea.value)\" (blur)=\"saveData(textarea.value)\" class=\"editable\">{{value}}</textarea>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/edit/edit.component.html
// module id = 191
// module chunks = 1